import { render, staticRenderFns } from "./invitations.vue?vue&type=template&id=351c0ed5&scoped=true"
import script from "./invitations.vue?vue&type=script&lang=js"
export * from "./invitations.vue?vue&type=script&lang=js"
import style0 from "./invitations.vue?vue&type=style&index=0&id=351c0ed5&prod&scoped=true&lang=css"
import style1 from "./invitations.vue?vue&type=style&index=1&id=351c0ed5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351c0ed5",
  null
  
)

export default component.exports